import { PropsWithChildren } from 'react'

export const PlainText = ({ children }: PropsWithChildren) => {
  const DOM_PARSER = new DOMParser()
  const decodeHtmlAndStripTags = (html: string) => {
    if (!html) {
      return ''
    }

    try {
      const decodedHtml = document.createElement('textarea')
      decodedHtml.innerHTML = html
      const doc = DOM_PARSER.parseFromString(decodedHtml.value, 'text/html')
      return doc.body.textContent || ''
    } catch (error) {
      console.error('Error while parsing HTML:', error)
      return ''
    }
  }

  // TODO: fix children type
  return decodeHtmlAndStripTags(children as string)
}
